import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/K.png")